<p>hr-detail works!</p>
